import React from 'react';
export function WhyIngredientsMatter() {
  return <section className="py-20 bg-slate-50" data-id="element-1205">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg prose-slate" data-id="element-1206">
        <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-6 text-center" data-id="element-1207">
          Why Ingredients Matter
        </h2>
        <p data-id="element-1208">
          Understanding <strong data-id="element-1209">why ingredients matter</strong> is the first
          step toward reclaiming your health. We live in an era of
          ultra-processed foods, where convenience often comes at the expense of
          nutritional value. While the front of a package might boast claims
          like "All Natural," "Low Fat," or "Made with Real Fruit," the
          ingredient list on the back tells the true story.
        </p>
        <p data-id="element-1210">
          The ingredients you consume daily compound over time. Consistently
          eating foods packed with artificial preservatives, synthetic food dyes
          (like Red 40 and Yellow 5), and hidden sugars (like high-fructose corn
          syrup) has been strongly linked to a rise in chronic health
          conditions. These include obesity, type 2 diabetes, cardiovascular
          disease, systemic inflammation, and even behavioral issues in
          children.
        </p>
        <p data-id="element-1211">
          When you pay attention to ingredients, you shift your focus from
          simply counting calories to evaluating the actual quality of the fuel
          you are putting into your body. Whole, recognizable ingredients
          provide the essential vitamins, minerals, and macronutrients your body
          needs to repair cells, boost immunity, and maintain steady energy
          levels. Conversely, highly processed additives force your liver and
          digestive system to work overtime to process synthetic compounds that
          offer zero nutritional benefit.
        </p>
        <p data-id="element-1212">
          By learning to read labels—or by letting an app like IntelliEats do it
          for you—you take back control. You protect your family from deceptive
          marketing and ensure that the food you buy actually supports a long,
          vibrant, and healthy life.
        </p>
      </div>
    </section>;
}